module.exports = __webpack_public_path__ + "img/GAME_COLORDRAW2.f386bd30.jpg";